import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizAllBanner from "../../../../styles/img/quiz-all-banner.png";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBaner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr, UiContentPinkCol } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import { QuizzerCard } from "./Views/QuizzerCard";
import volvoLogo from '../../../../styles/img/volvo-logo-round.png';
import Footer from "../../components/footer/Footer";
import { UiNavTabs, UiNavTab } from "../../components/common/UiNavTabs"
import BadgesBox from "../../components/common/BadgesBox"
import { KnowledgeHowToEarn } from "./Views/KnowledgeHowToEarn";
import GetBadges from "./Views/GetBadges"

export const ViewBadges = () => {
    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBaner
                    title="Learning History"
                    description="See what courses you’ve completed!"
                    sliderCardImage={quizAllBanner}
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Knowledge"
                    prevPageLink="/ui"
                    currentPage="  Learning History"
                    currentPageLink="/ui/incentives-pre-register" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-top-tab-area">
                        <UiContentCol>
                            <UiNavTabs>
                                <UiNavTab eventKey="Primary Badges" title="Primary Badges">
                                    <UiSingleRow >
                                        <UiCol lg="11" >
                                            <UiSingleRow className="row-cols-1 row-cols-lg-2 row-cols-xl-5">
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                            </UiSingleRow>
                                        </UiCol>
                                    </UiSingleRow>
                                </UiNavTab>

                                <UiNavTab eventKey="Additional Badges" title="Additional Badges">
                                    <UiSingleRow >
                                        <UiCol lg="11" >
                                            <UiSingleRow className="row-cols-1 row-cols-lg-2 row-cols-xl-5">
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                                <BadgesBox badgeName="Badge Name" />
                                            </UiSingleRow>
                                        </UiCol>
                                    </UiSingleRow>
                                </UiNavTab>
                            </UiNavTabs>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr>
                    <UiContentPinkCol>
                        <GetBadges/>
                    </UiContentPinkCol>
                </UiContentWr>
                <KnowledgeHowToEarn />
                <Footer />

            </UiMainWrapper>


        </>
    )
}
